export default {"src":"/_next/static/media/arrow-right-circle.3c5c3eca.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};